export function getListingPriceFromDOM (listingId) {
  return document.querySelector(`[data-id="${listingId}"]`)?.dataset?.price
}
